import { render, staticRenderFns } from "./info-item.vue?vue&type=template&id=56bf531c&scoped=true&"
import script from "./info-item.vue?vue&type=script&lang=js&"
export * from "./info-item.vue?vue&type=script&lang=js&"
import style0 from "./info-item.vue?vue&type=style&index=0&id=56bf531c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bf531c",
  null
  
)

export default component.exports